var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.buttonVisible)?_c('v-btn',_vm._b({staticClass:"google-pay-button",on:{"click":_vm.buttonClick}},'v-btn',_vm.$attrs,false),[_c('e-svg-icon',{attrs:{"size":"xbg"}},[_vm._v("google-pay")])],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }